import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getApiBase } from '@papan/api-client'

/**
 * Post-login continue for a quick-view (folder/file) private gate's "Sign in with
 * <brand>" button — the quick-view twin of AppSignInContinuePage.
 *
 * A logged-out click lands on `-api /share/<token>/choose-identity?signin=1`, which sends
 * the visitor to `…/login?next=/share-signin/<token>` (a RELATIVE frontend path, so
 * `safeNext` accepts it). After login, LoginPage lands them HERE, and this route hops
 * (client-side) back to choose-identity on the `-api` origin — where the host-only Better
 * Auth cookie is visible — which admits them (or shows the identity picker) and hops on to
 * `/share-view`. It deliberately omits `signin=1`: if the login didn't stick,
 * choose-identity bounces to the gate instead of back to the login (no loop).
 *
 * The destination is `getApiBase()` + the encoded path token + our own origin (validated
 * server-side against the trusted-origin allowlist) — no caller-supplied URL.
 */
export function ShareSignInContinuePage() {
  const { token } = useParams<{ token: string }>()

  useEffect(() => {
    if (!token || !/^[A-Za-z0-9_-]{1,120}$/.test(token)) {
      window.location.replace('/')
      return
    }
    window.location.replace(
      `${getApiBase()}/share/${encodeURIComponent(token)}/choose-identity?app=${encodeURIComponent(window.location.origin)}`,
    )
  }, [token])

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#71717a', fontFamily: 'ui-sans-serif, system-ui, sans-serif', fontSize: 14 }}>
      Signing you in…
    </div>
  )
}
